import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '@/views/Dashboard.vue'
import Recognition from '@/views/OnlineTest.vue'   // 改名为 Recognition，但文件仍可叫 OnlineTest.vue
import History from '@/views/History.vue'
import ModelHistory from '@/views/ModelHistory.vue'
import ModelTester from "@/views/ModelTester.vue";

const routes = [
  { path: '/', redirect: '/dashboard' },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/recognition', name: 'Recognition', component: Recognition },
  { path: '/history', name: 'History', component: History },
  { path: '/model-history', name: 'ModelHistory', component: ModelHistory },
  { path: '/model-tester', name: 'ModelTester', component: ModelTester }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router